import { jsx } from "react/jsx-runtime";
import React from "react";
var notice_red_small_default = (prefix = "") => {
  return [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17 9c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8 3.5817-8 8-8 8 3.5817 8 8z",
        fill: "rgb(var(--colour-semantic-negative, 224, 7, 81))"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 9.5V5h2v4.5H8z",
        fill: "rgb(var(--colour-text-and-icon-5, 255, 255, 255))"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.25 12.25c0 .6904-.5596 1.25-1.25 1.25s-1.25-.5596-1.25-1.25S8.3096 11 9 11s1.25.5596 1.25 1.25z",
        fill: "rgb(var(--colour-text-and-icon-5, 255, 255, 255))"
      }
    )
  ];
};
export {
  notice_red_small_default as default
};
